import type { ITSPayloadBet, ITSPayloadBoard } from '../../@types/ITSPayload.js';
import BoardNumboards, { type ITSNumboardsBoard } from '../board/BoardNumboards.js';
import Bet from './Bet.js';

type ITSERNumbBoards = ITSPayloadBet<{
  erNumberBoardData: {
    boards: ITSPayloadBoard<string>[];
  };
}>;

type ITSNumBoards = ITSPayloadBet<{
  numberBoards: ITSNumboardsBoard[];
}>;

/**
 * Bet class for numberboards products.
 * Contains product specific logic for eg. reduction systems like RSYS and USYS.
 */
class BetNumberBoards extends Bet<BoardNumboards> {
  getSystemLabel(): string {
    // if (this.systemNumber) {
    //   return systems.getSystemKeyFromNumber(this.systemNumber);
    // }

    const [board] = this.boards;
    const systemType = board?.systemType;

    // Since 'getRowCount' is using factorial in the M system to calculate total rows we can't
    // reverse that to get the base for the system label. Instead we'll use the board data to
    // get the selection length
    const rows = board?.getBoardData().length ?? 0;

    if (systemType === 'RSYS') {
      return `R ${rows}`;
    }
    if (systemType === 'MSYS') {
      return `M ${rows}`;
    }

    return `S ${rows}`;
  }

  /**
   * Loops over boards to generate correct data for all boards.
   *
   * @returns Object with correct ITS structure for numboards external systems
   */
  protected composeOwnRowsBoards(): ITSERNumbBoards {
    const boards = this.boards.map((board) => board.composeOwnRows());

    const itsPayload = { erNumberBoardData: { boards } };

    type ITSBetNumboards = ITSPayloadBet<typeof itsPayload>;

    return itsPayload as ITSBetNumboards;
  }

  protected composeBoards(): ITSNumBoards {
    const numberBoards = this.boards.map((board) => board.compose());

    const itsPayload = {
      numberBoards,
    };

    type ITSBetNumboards = ITSPayloadBet<typeof itsPayload>;

    return itsPayload as ITSBetNumboards;
  }

  protected getBoard(): BoardNumboards {
    return new BoardNumboards(this.product);
  }
}

export default BetNumberBoards;
